const VendorTendersPage = () => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <h1 className="text-2xl font-bold text-gray-900">Tenders</h1>
      </div>

      <div className="w-full bg-white shadow rounded-lg overflow-hidden">
        <div className="py-16 text-center text-gray-400 text-sm">
          No tenders available yet.
        </div>
      </div>
    </div>
  );
};

export default VendorTendersPage;
